import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cached = null;
let inflight = null;

async function loadProduct() {
  let r = await fetch(`${API}/shopify/product`);
  if (r.status === 404) {
    // first visit on a fresh environment — sync the catalog, then retry once
    await fetch(`${API}/shopify/sync`, { method: "POST" }).catch(() => {});
    r = await fetch(`${API}/shopify/product`);
  }
  return r.ok ? r.json() : null;
}

export function fetchShopProduct() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = loadProduct()
      .then((d) => {
        cached = d;
        return d;
      })
      .catch(() => null);
  }
  return inflight;
}

export function useShopProduct() {
  const [product, setProduct] = useState(cached);
  useEffect(() => {
    let mounted = true;
    fetchShopProduct().then((d) => {
      if (mounted && d) setProduct(d);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return product;
}
